// extracted by css-extract-rspack-plugin
export default {"input":"Search-module__input__KcCbd_g"};